<button class="btn times">Time: {{ hour }} hour {{ minute }} min {{ second }} sec</button>